import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <Box
      component="footer"
      sx={{
        p: 3,
        textAlign: "center",
        bgcolor: "background.paper",
        borderTop: "1px solid",
        borderColor: "divider",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "center", gap: 3, mb: 2 }}>
        <Typography
          component={RouterLink}
          to="/"
          variant="body2"
          sx={{ textDecoration: "none", color: "text.secondary" }}
        >
          {t("Dashboard")}
        </Typography>
        <Typography
          component={RouterLink}
          to="/gec"
          variant="body2"
          sx={{ textDecoration: "none", color: "text.secondary" }}
        >
          {t("GECTitle")}
        </Typography>
        <Typography
          component={RouterLink}
          to="hrc"
          variant="body2"
          sx={{ textDecoration: "none", color: "text.secondary" }}
        >
          {t("HRCTitle")}
        </Typography>
        <Typography
          component={RouterLink}
          to="/moph"
          variant="body2"
          sx={{ textDecoration: "none", color: "text.secondary" }}
        >
          {t("MOPHTitle")}
        </Typography>
        <Typography
          component={RouterLink}
          to="/south"
          variant="body2"
          sx={{ textDecoration: "none", color: "text.secondary" }}
        >
          {t("South CouncilTitle")}
        </Typography>
        <Typography
          component={RouterLink}
          to="/faq"
          variant="body2"
          sx={{ textDecoration: "none", color: "text.secondary" }}
        >
          {t("FAQ")}
        </Typography>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Box 
        component="a"
        href="https://elgherbal.org/"
        target="_blank"
        rel="noopener noreferrer"
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          gap: 2, 
          mb: 2,
          flexWrap: 'wrap',
          textDecoration: 'none',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          borderRadius: 1,
          p: 1,
          '&:hover': {
            transform: 'translateY(-1px)',
            opacity: 0.9
          }
        }}
      >
        <img 
          src="/gh.png" 
          alt="Gherbal Initiative" 
          style={{ 
            height: '80px',
            width: 'auto',
            opacity: 0.7
          }}
        />
        <Typography variant="body2" color="text.secondary">
          {t("Powered by Gherbal Initiative")}
        </Typography>
      </Box>
      <Typography variant="body2" color="text.secondary">
        © {new Date().getFullYear()} {t("footerTitle")}
      </Typography>
    </Box>
  );
};

export default Footer;
